module.exports = __webpack_public_path__ + "img/dialog.b08a8093.png";